// Render Prop

import React, { Component } from 'react';
import { Redirect } from 'react-router';


import { Label, Input } from 'reactstrap';
import TableWidget from "../../widgets/TableWidget";


export class SelectStudent extends Component {
    static displayName = SelectStudent.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            selectedStudent: false,
            filterText: ""
        };

        this.props.store.updateBanner("Update Student");

        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSubmission = this.handleSubmission.bind(this);
    }


    handleSubmission(event) {
        const id = event.target.value;
        this.setState({ selectedStudent: id })
    }

    async handleFilterChange(event) {
        await this.setState({ filterText: event.target.value });
    }

    studentSelect() {
        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    <Label for="studentFilter">Filter By Name or TUID</Label>
                    <Input placeHolder="Student Name / TUID..." type="text" id="studentFilter" value={this.state.filterText} onChange={this.handleFilterChange} />
                </div>
            </div>
        )
    }

    render() {
        if (!this.state.selectedStudent) {
            return (
                <div>
                    {this.studentSelect()}
                    {this.selectForm()}
                </div>);
        }
        else {
            return (<Redirect push to={"/staff/Student/" + this.state.selectedStudent} />);
        }
    }

    selectForm() {
        /*const options = students.map(student => {
            return {
                label: student.name,
                value: student.id
            }
        });*/

        const leftAlignCellProps = (state, rowInfo, column) => {
            return {
                style: {
                    textAlign: "right"
                }
            };
        }

        const columns =
            [
                {
                    Header: "", accessor: "col1",
                    Cell: (props) => (
                        <button className="btn btn-light" value={props.cell.value} onClick={this.handleSubmission}>
                            Edit
                        </button>
                    ),
                    props: {
                        colspan: "1", style: { width: "10%", borderBottom: "3px solid white" }
                    }
                },
                { Header: "Name", accessor: "col2", props: { colSpan: "1", style: { width: "25%" } } },
                {
                    Header: "TUID", accessor: "col3", props: { colSpan: "1", style: { width: "25%" } }
                },
                {
                    Header: "Email", accessor: "col4", props: { colSpan: "1", style: { width: "10%", textAlign: "right" } },
                    Cell: (props) => (<div style={{ textAlign: "right" }}>{props.value}</div >)
                },
                {
                    Header: "Accounts", accessor: "col5", props: { colSpan: "1", style: { width: "10%", textAlign: "right" } },
                    Cell: (props) => (<div style={{ textAlign: "right" }}>{props.value}</div >)
                },
                {
                    Header: "Award", accessor: "col6", props: { colSpan: "1", style: { width: "10%", textAlign: "right" } },
                    Cell: (props) => (<div style={{ textAlign: "right" }}>{props.value}</div >)
                },
                {
                    Header: "Balance", accessor: "col7", props: { colSpan: "1", style: { width: "10%", textAlign: "right" } },
                    Cell: (props) => (<div style={{ textAlign: "right" }}>{props.value}</div >)
                }
            ];


        let students = this.props.store.students.collection;
        //console.log("students: ", students);
        //Sort employers by last name; 
        students.sort(this.props.store.students.sortByLastName);

        students = students.filter(student => {
            return student.name.toLowerCase().includes(this.state.filterText.toLowerCase())
                || student.tuid.includes(this.state.filterText)
        });

        //We use memo to reduce recalculations. ;
        const data = students.map(student => {
            return {
                col1: student.id,
                col2: student.name,
                col3: student.tuid,
                col4: student.email,
                col5: student.accountIds.length,
                col6: `$${student.awardAmount.toFixed(2)}`,
                col7: `$${student.balance.toFixed(2)}`
            }
        });



        return (
            <TableWidget
                tableProps={{ style: "mt-4" }}
                headerGroupProps={{}}
                rowProps={{}}
                columns={columns}
                data={data} />
        )
    }
}
